import Vue from 'vue';

export default {
  // 注册
  registerUser(params) {
    return Vue.axios.post('/api/v1.0/chanquan/user/registerUser', params);
  },
  // 获取联行号列表
  getBankCorrespond(params) {
    return Vue.axios.post('/api/v1.0/chanquan/acc/selectBankCorrespond', params);
  }
};
